module.exports = __webpack_public_path__ + "static/hero_header-574d0879d85f5fe8542657c4b4fb9d77.png";